import React from 'react';
import styled from 'styled-components';
import ProfileDropdown from './ProfileDropdown';
import ProfileButton from './ProfileButton';

const Container = styled.div`
	position: relative;
	flex-shrink: 0;
`;

class ProfileSection extends React.Component {
	state = {
		showDropdown: false,
	};

	toggleDropdown = () => {
		this.setState({
			showDropdown: !this.state.showDropdown,
		});
	};

	dropdownClick = event => {
		this.setState({
			showDropdown: false,
		});
	};

	logoutClick = () => {
		this.dropdownClick();
		this.props.logout();
	};

	render() {
		const { user } = this.props;

		return (
			<Container>
				<ProfileButton user={user} toggleDropdown={this.toggleDropdown} />

				<ProfileDropdown
					user={user}
					visible={this.state.showDropdown}
					click={this.dropdownClick}
					logout={this.logoutClick}
				/>
			</Container>
		);
	}
}

export default ProfileSection;



// WEBPACK FOOTER //
// ./src/components/TopBar/ProfileSection.js